<div class="flex flex-col justify-center w-full h-full relative">
  <app-header *ngIf="!isPageWithHeader"></app-header>

  <main class="flex-1 h-auto overflow-auto min-h-0">
    <router-outlet></router-outlet>
  </main>

  @if (showFooterMain) {
  <footer class="fixed bottom-0 left-auto w-full z-50 animation-slide-up">
    <!-- @if (currentUrl.includes('/parking-center')) {
    <div class="relative flex justify-center z-10  animation-close-up-footer">
      <button (click)="toggleFooter()"
        class="flex items-center justify-center w-16 h-5 bg-white/75 backdrop-blur-md shadow-[0_-2px_10px_rgba(0,0,0,0.05)] rounded-t-xl text-gray-400 hover:text-yellow-500 transition-colors">
        @if (isFooterCollapsed) {
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor"
          class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
        </svg>
        } @else {
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor"
          class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
        }
      </button>
    </div>
    } -->
    <div [class.hidden]="isFooterCollapsed && currentUrl.includes('/parking-center')"
      class="bg-white/95 backdrop-blur-md shadow-[0_-5px_20px_rgba(0,0,0,0.1)] border-t border-gray-100 rounded-t-[30px] transition-all duration-300  animation-slide-up">

      <div class="grid grid-cols-5 w-full max-w-md mx-auto h-[80px]">

        <!-- หน้าหลัก (Home) -->
        <a href="/home"
          class="group flex flex-col justify-center items-center w-full h-full transition-all duration-300 ease-out cursor-pointer relative"
          (click)="currentUrl = '/home'">

          <div class="absolute top-0 w-8 h-1 bg-yellow-400 rounded-b-full transition-all duration-300"
            [class.opacity-100]="currentUrl === '/home'" [class.opacity-0]="currentUrl !== '/home'">
          </div>

          <div class="w-6 h-6 mb-1 transition-transform duration-300 group-active:scale-90"
            [class.-translate-y-1]="currentUrl === '/home'">
            <img src="/icons/home-home.png" class="w-full h-full object-contain transition-opacity duration-300"
              [class.opacity-0]="currentUrl === '/home'" [class.absolute]="currentUrl === '/home'" />
            <img src="/icons/home-home-yellow.png" class="w-full h-full object-contain transition-opacity duration-300"
              [class.opacity-0]="currentUrl !== '/home'" [class.hidden]="currentUrl !== '/home'"
              [class.opacity-100]="currentUrl === '/home'" />
          </div>

          <span class="text-[9px] font-medium transition-colors duration-300"
            [class.text-yellow-500]="currentUrl === '/home'" [class.font-bold]="currentUrl === '/home'"
            [class.text-gray-400]="currentUrl !== '/home'">
            {{ currentLang === "TH" ? "หน้าหลัก" : "Home"}}
          </span>
        </a>

        <!-- รายการจอด (Parking List) -->
        <a href="/check-amount-parking"
          class="group flex flex-col justify-center items-center w-full h-full transition-all duration-300 ease-out cursor-pointer relative"
          (click)="currentUrl = '/check-amount-parking'">

          <div class="absolute top-0 w-8 h-1 bg-yellow-400 rounded-b-full transition-all duration-300"
            [class.opacity-100]="currentUrl === '/check-amount-parking'"
            [class.opacity-0]="currentUrl !== '/check-amount-parking'">
          </div>

          <div class="w-6 h-6 mb-1 transition-transform duration-300 group-active:scale-90 relative"
            [class.-translate-y-1]="currentUrl === '/check-amount-parking'">
            <img src="/icons/count_parking-gray.png"
              class="w-full h-full object-contain transition-opacity duration-300"
              [class.opacity-0]="currentUrl === '/check-amount-parking'"
              [class.absolute]="currentUrl === '/check-amount-parking'" />
            <img src="/icons/count_parking-yellow.png"
              class="w-full h-full object-contain transition-opacity duration-300"
              [class.opacity-0]="currentUrl !== '/check-amount-parking'"
              [class.hidden]="currentUrl !== '/check-amount-parking'"
              [class.opacity-100]="currentUrl === '/check-amount-parking'" />

            <!-- การแจ้งเตือน -->
            <div class="absolute -top-1 -right-1 z-20" *ngIf="homeTopUpData.vehicleCount > 0">
              <span class="relative flex h-3.5 w-3.5">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span
                  class="relative inline-flex rounded-full h-3.5 w-3.5 bg-red-500 text-white text-[8px] font-bold justify-center items-center">
                  {{ homeTopUpData.vehicleCount }}
                </span>
              </span>
            </div>
          </div>

          <span class="text-[9px] font-medium transition-colors duration-300"
            [class.text-yellow-500]="currentUrl === '/check-amount-parking'"
            [class.font-bold]="currentUrl === '/check-amount-parking'"
            [class.text-gray-400]="currentUrl !== '/check-amount-parking'">
            {{ currentLang === "TH" ? "รายการจอด" : "Parking"}}
          </span>
        </a>

        <!-- Ev charger -->
        <a href="/ev-charger"
          class="relative flex flex-col justify-center items-center w-full h-full cursor-pointer group"
          (click)="currentUrl = '/ev-charger'">
          <div
            class="absolute -top-[16px] w-14 h-14 bg-gradient-to-tr from-yellow-500 to-amber-400 rounded-full shadow-[0_4px_12px_rgba(245,158,11,0.3)] flex items-center justify-center pl-1 border-4 border-white transition-all duration-300 hover:scale-110 active:scale-95">
            <img src="/icons/charge-home-white.png" alt="ev-charging" class="w-6 h-6 object-contain">

            <!-- การแจ้งเตือน -->
            <div class="absolute top-0 right-0 z-20" *ngIf="homeTopUpData.evCount > 0">
              <span class="relative flex h-3.5 w-3.5">
                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span
                  class="relative inline-flex rounded-full h-3.5 w-3.5 bg-red-500 text-white text-[8px] font-bold justify-center items-center">
                  {{ homeTopUpData.evCount }}
                </span>
              </span>
            </div>
          </div>
          <span class="text-[8px] font-bold mt-6 transition-colors select-none"
            [class.text-yellow-500]="currentUrl === '/ev-charger'" [class.text-gray-400]="currentUrl !== '/ev-charger'">
            {{ currentLang === "TH" ? "EV charger" : "EV charger" }}
          </span>
        </a>

        <!-- จุดจอดรถ (Parking Map) -->
        <a href="/parking-center"
          class="group flex flex-col justify-center items-center w-full h-full transition-all duration-300 ease-out cursor-pointer relative"
          (click)="currentUrl = '/parking-center'">

          <div class="absolute top-0 w-8 h-1 bg-yellow-400 rounded-b-full transition-all duration-300"
            [class.opacity-100]="currentUrl === '/parking-center'" [class.opacity-0]="currentUrl !== '/parking-center'">
          </div>

          <div class="w-6 h-6 mb-1 transition-transform duration-300 group-active:scale-90"
            [class.-translate-y-1]="currentUrl === '/parking-center'">
            <img src="/icons/marker-home.png" class="w-full h-full object-contain transition-opacity duration-300"
              [class.opacity-0]="currentUrl === '/parking-center'"
              [class.absolute]="currentUrl === '/parking-center'" />
            <img src="/icons/marker-home-yellow.png"
              class="w-full h-full object-contain transition-opacity duration-300"
              [class.opacity-100]="currentUrl === '/parking-center'" [class.hidden]="currentUrl !== '/parking-center'"
              [class.opacity-0]="currentUrl !== '/parking-center'" />
          </div>

          <span class="text-[9px] font-medium transition-colors duration-300"
            [class.text-yellow-500]="currentUrl === '/parking-center'"
            [class.font-bold]="currentUrl === '/parking-center'"
            [class.text-gray-400]="currentUrl !== '/parking-center'">
            {{ currentLang === "TH" ? "จุดจอดรถ" : "Parking Map"}}
          </span>
        </a>

        <!-- โปรไฟล์ (Profile) -->
        <a href="/profile"
          class="group flex flex-col justify-center items-center w-full h-full transition-all duration-300 ease-out cursor-pointer relative"
          (click)="currentUrl = '/profile'">

          <div class="absolute top-0 w-8 h-1 bg-yellow-400 rounded-b-full transition-all duration-300"
            [class.opacity-100]="currentUrl === '/profile'" [class.opacity-0]="currentUrl !== '/profile'"></div>

          <div class="w-6 h-6 mb-1 transition-transform duration-300 group-active:scale-90"
            [class.-translate-y-1]="currentUrl === '/profile'">
            <img src="/icons/person-home.png" class="w-full h-full object-contain transition-opacity duration-300"
              [class.opacity-0]="currentUrl === '/profile'" [class.absolute]="currentUrl === '/profile'" />
            <img src="/icons/person-home-yellow.png"
              class="w-full h-full object-contain transition-opacity duration-300"
              [class.opacity-100]="currentUrl === '/profile'" [class.hidden]="currentUrl !== '/profile'"
              [class.opacity-0]="currentUrl !== '/profile'" />
          </div>

          <span class="text-[9px] font-medium transition-colors duration-300"
            [class.text-yellow-500]="currentUrl === '/profile'" [class.font-bold]="currentUrl === '/profile'"
            [class.text-gray-400]="currentUrl !== '/profile'">
            {{ currentLang === "TH" ? "โปรไฟล์" : "Profile"}}
          </span>
        </a>

      </div>

      <div class="h-safe-bottom w-full bg-white/95 backdrop-blur-md"></div>
    </div>
  </footer>
  }

</div>

<!-- CRITICAL: Place the app-pss-loading outside the outermost main div wrapper -->
<app-pss-loading *ngIf="isLoadingBarrier" text="กำลังติดต่ออุปกรณ์ไม้กั้น"
  detail="โปรดรอสักครู่ . . ."></app-pss-loading>
<app-pss-success *ngIf="isSuccessBarrier" (close)="isSuccessBarrier = $event" [timeIn]="3000"
  [text]="textSuccessBarrier" [detail]="detailSuccessBarrier"></app-pss-success>